import commonText from './commonText';

const printModes = {
  print: {
    displayLabel: 'Local Print',
    initialSelected: false,
    initialImpactFactor: 1,
    initialDiscount: 0.25,
    costText: '(cost of single placement)',
    costTooltip: '(cost of single placement)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'newspaper-o',
  },
  natl_print: {
    displayLabel: 'Natl Print',
    initialSelected: false,
    initialImpactFactor: 1,
    initialDiscount: 0.25,
    costText: '(cost of single placement)',
    costTooltip: '(cost of single placement)',
    frequencyText: commonText.frequencyText,
    frequencyTooltip: commonText.frequencyTooltip,
    percentText: commonText.percentText,
    percentTooltip: commonText.percentTooltip,
    impactFactorText: commonText.impactFactorText,
    impactFactorTooltip: commonText.impactFactorTooltip,
    discountTooltip: commonText.discountTooltip,
    icon: 'newspaper-o',
  },
};

export default printModes;
